// Helpers y constantes compartidas por los componentes de Ops Dashboard.

export const API_URL = process.env.REACT_APP_BACKEND_URL;

export const ADMIN_EMAILS = [
  'c.merinoherrero@gmail.com',
  'emprendeconciente1111@gmail.com',
  'admin@invictus.trading',
  'admin@profitswarm.com',
];

export const BOT_LABELS = {
  hyperliquid: 'Hyperliquid (Crypto SMA)',
  ftmo: 'FTMO Gold',
  ic_markets_lbfp: 'IC Markets · LBFP (H1)',
  sniper: 'Sniper · XAUUSD (M1)',
  sentimental: 'Sentimental · BTC (M15)',
};

export const BOT_COLORS = {
  hyperliquid: '#a855f7', // violet
  ftmo: '#f59e0b',        // amber gold
  ic_markets_lbfp: '#10b981', // emerald
  sniper: '#eab308',      // gold (XAUUSD)
  sentimental: '#f97316', // orange (BTC)
};

export const TIMEFRAMES = [
  { id: '1d',  label: '24h', days: 1 },
  { id: '7d',  label: '7d',  days: 7 },
  { id: '30d', label: '30d', days: 30 },
  { id: '90d', label: '90d', days: 90 },
  { id: 'all', label: 'All', days: 3650 },
];

export const WEEKDAY_LABELS = ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'];

export const formatUSD = (v, decimals = 2) => {
  const n = typeof v === 'number' ? v : parseFloat(v) || 0;
  return `$${n.toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals })}`;
};

export const formatUSDCompact = (v) => {
  const n = typeof v === 'number' ? v : parseFloat(v) || 0;
  const abs = Math.abs(n);
  if (abs >= 1_000_000) return `${n < 0 ? '-' : ''}$${(abs / 1_000_000).toFixed(2)}M`;
  if (abs >= 1_000) return `${n < 0 ? '-' : ''}$${(abs / 1_000).toFixed(2)}k`;
  return formatUSD(n);
};

export const formatPct = (v, decimals = 2) =>
  `${(typeof v === 'number' ? v : parseFloat(v) || 0).toFixed(decimals)}%`;

export const formatNum = (v, decimals = 2) =>
  (typeof v === 'number' ? v : parseFloat(v) || 0).toFixed(decimals);

export const formatTs = (s) =>
  s ? new Date(s).toLocaleString('es-ES', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : '—';

export const formatDateOnly = (s) =>
  s ? new Date(s).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: '2-digit' }) : '—';

export const authHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export async function apiGet(path) {
  const r = await fetch(`${API_URL}${path}`, { headers: authHeaders() });
  if (r.status === 401) {
    // Sesión caducada o token inválido: limpiar y redirigir al login.
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    if (!window.location.pathname.startsWith('/login')) {
      window.location.href = '/login';
    }
    throw new Error('Sesión caducada, vuelve a iniciar sesión');
  }
  if (!r.ok) throw new Error(`HTTP ${r.status}`);
  return r.json();
}

export async function apiPost(path, body) {
  const r = await fetch(`${API_URL}${path}`, {
    method: 'POST',
    headers: { ...authHeaders(), 'Content-Type': 'application/json' },
    body: body != null ? JSON.stringify(body) : undefined,
  });
  if (r.status === 401) {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    if (!window.location.pathname.startsWith('/login')) {
      window.location.href = '/login';
    }
    throw new Error('Sesión caducada, vuelve a iniciar sesión');
  }
  if (!r.ok) throw new Error(`HTTP ${r.status}`);
  return r.json();
}

export async function apiPut(path, body) {
  const r = await fetch(`${API_URL}${path}`, {
    method: 'PUT',
    headers: { ...authHeaders(), 'Content-Type': 'application/json' },
    body: body != null ? JSON.stringify(body) : undefined,
  });
  if (r.status === 401) {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    if (!window.location.pathname.startsWith('/login')) {
      window.location.href = '/login';
    }
    throw new Error('Sesión caducada, vuelve a iniciar sesión');
  }
  if (!r.ok) throw new Error(`HTTP ${r.status}`);
  return r.json();
}

export async function apiDelete(path) {
  const r = await fetch(`${API_URL}${path}`, {
    method: 'DELETE',
    headers: authHeaders(),
  });
  if (r.status === 401) {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    if (!window.location.pathname.startsWith('/login')) {
      window.location.href = '/login';
    }
    throw new Error('Sesión caducada, vuelve a iniciar sesión');
  }
  if (!r.ok) throw new Error(`HTTP ${r.status}`);
  return r.json();
}

// Exporta lista de trades a CSV
export function tradesToCsv(trades) {
  const headers = [
    'opened_at', 'closed_at', 'bot_id', 'market', 'strategy', 'direction',
    'entry_price', 'sl_price', 'tp_price', 'exit_price', 'size', 'pnl_usd',
    'exit_reason', 'duration_sec',
  ];
  const rows = trades.map((t) =>
    headers.map((h) => {
      const v = t[h];
      if (v == null) return '';
      const s = String(v).replace(/"/g, '""');
      return /[",\n]/.test(s) ? `"${s}"` : s;
    }).join(',')
  );
  return [headers.join(','), ...rows].join('\n');
}

export function downloadCsv(filename, content) {
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
